import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link, Navigate, useNavigate } from "react-router-dom";

export default function Register() {
    const { user, register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "" });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    if (user) return <Navigate to="/" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await register(form.email, form.password, form.name);
        setLoading(false);
        if (!res.ok) setError(res.error);
        else nav("/");
    };

    return (
        <div className="min-h-screen grain flex items-center justify-center p-6 bg-[color:var(--bl-bg)]">
            <form onSubmit={onSubmit} className="w-full max-w-md border border-[color:var(--bl-border)] bg-[color:var(--bl-surface)] p-8 rounded-sm shadow-sm" data-testid="register-form">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/bull.png" alt="" className="w-10 h-10" />
                    <div>
                        <h1 className="font-serif-display text-3xl text-[color:var(--bl-text)]">Create account</h1>
                        <p className="text-xs uppercase tracking-[0.2em] text-[color:var(--bl-text-dim)]">Takealot Insight</p>
                    </div>
                </div>

                {error && (
                    <div data-testid="register-error" className="mb-4 p-3 text-sm bg-[color:var(--bl-danger)]/10 border border-[color:var(--bl-danger)]/40 text-[color:var(--bl-danger)] rounded-sm">{error}</div>
                )}

                <label className="block text-xs uppercase tracking-wider text-[color:var(--bl-text-dim)] mb-2">Name</label>
                <input data-testid="register-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full bg-[color:var(--bl-bg)] border border-[color:var(--bl-border)] px-3 py-2 rounded-sm focus:outline-none focus:border-[color:var(--bl-takealot-blue)] mb-4" />

                <label className="block text-xs uppercase tracking-wider text-[color:var(--bl-text-dim)] mb-2">Email</label>
                <input data-testid="register-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    className="w-full bg-[color:var(--bl-bg)] border border-[color:var(--bl-border)] px-3 py-2 rounded-sm focus:outline-none focus:border-[color:var(--bl-takealot-blue)] mb-4" />

                <label className="block text-xs uppercase tracking-wider text-[color:var(--bl-text-dim)] mb-2">Password</label>
                <input data-testid="register-password-input" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                    className="w-full bg-[color:var(--bl-bg)] border border-[color:var(--bl-border)] px-3 py-2 rounded-sm focus:outline-none focus:border-[color:var(--bl-takealot-blue)] mb-6" />

                <button data-testid="register-submit-btn" disabled={loading} type="submit" className="w-full bg-[color:var(--bl-takealot-blue)] text-white font-medium py-2.5 rounded-sm hover:brightness-110 transition disabled:opacity-50">
                    {loading ? "Creating…" : "Create account"}
                </button>

                <div className="mt-6 text-xs text-[color:var(--bl-text-dim)] text-center">
                    Already registered? <Link data-testid="goto-login-link" to="/login" className="text-[color:var(--bl-takealot-orange)] hover:underline">Sign in</Link>
                </div>
            </form>
        </div>
    );
}
